import styled from 'styled-components';

export const SitesWrapper = styled('div')``;
